import { styled } from '@mui/material';
import { IntervalLayoutProps } from '../types';
import { EntryDrawer } from './EntryDrawer';

const ReportContent = styled('div')({
    minWidth: 0,
});

export default function View({
    children,
    editor,
    editorOpen,
    onEditorExited,
}: IntervalLayoutProps) {
    return (
        <>
            <ReportContent>{children}</ReportContent>
            {editor && (
                <EntryDrawer
                    key={editor.draft.uuid}
                    {...editor}
                    open={editorOpen && !!editor}
                    onExited={onEditorExited}
                />
            )}
        </>
    );
}
